var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgU(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 30.0514C134.359 29.4514 133.972 28.8089 133.63 28.2515C133.63 28.2941 133.63 28.2941 133.63 28.2515C126.901 16.5488 117.129 6.77357 105.429 1.52588e-05L89.1001 28.2515L86.0994 33.3956C91.7159 36.6546 96.4734 41.2839 99.8147 46.8575C100.157 47.3704 100.457 47.8852 100.757 48.4425C103.758 53.9311 105.429 60.1453 105.429 66.8356C105.429 81.153 97.6729 93.628 86.0994 100.272C80.4422 103.531 73.7558 105.418 66.7715 105.418C59.7426 105.418 53.1433 103.488 47.4861 100.187L44.4854 105.418L28.1582 133.582C39.515 140.186 52.8008 143.957 66.8585 144C80.9162 144 94.0704 140.271 105.429 133.669C117.129 126.896 126.943 117.078 133.672 105.375C134.015 104.816 134.359 104.216 134.7 103.616C140.614 92.6855 144 80.166 144 66.8356C144 53.5014 140.614 40.9839 134.7 30.0514Z",
    fill: "#DEE6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7713 66.8349H22.201L0 28.3805C0 28.3359 4.89917e-06 28.2934 0.0851328 28.2508C5.65714 18.5201 13.3283 10.1596 22.4583 3.73052C24.3002 2.40097 26.1846 1.19914 28.158 0.0863419L44.4851 28.2934L47.4859 33.4819L66.7713 66.8349Z",
    fill: "#DEE6F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.0a0d2d4cb3fe4d88b27b6ed5bcca7a03.svg";
export { ForwardRef as ReactComponent };